import {
  Box,
  FormControl,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Chip,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import EditIcon from "@mui/icons-material/Edit";

import React, { useEffect } from "react";
import { sizes } from "../../Setup/Scenario/scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";

const commonHeight = sizes.h35;

export default function ScenarioInfoForm() {
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.editScenarioNew);
  const {
    selectedCountry,
    scenarioName,
    periodType,
    periodTypes,
    createFromDate,
    createToDate,
    sentToSAP,
    scenarioStatus,
    editScDetails,
  } = setupState;
  const minSelectableDate = new Date();
  //const minSelectableDate = dayjs().startOf("month").toDate();
  const y = minSelectableDate.getFullYear();
  const m =
    minSelectableDate.getMonth() + 1 < 10
      ? `0${minSelectableDate.getMonth() + 1}`
      : minSelectableDate.getMonth() + 1;
  const d = "01";
  const minDate = `${y}-${m}-${d}`;
  const validFromDate = (date) => {
    console.log("From Date", date);
    if (periodType.length <= 0) {
      showMessage("Please select period type first", "info");
      return false;
    }
    if (periodType === "Weekly" && date.day() !== 1) {
      showMessage("Chosen day must be Monday for weekly period type", "info");
      return false;
    }
    if (periodType === "Monthly" && date.date() !== 1) {
      showMessage(
        "Chosen day must be first day of month for monthly period type",
        "info"
      );
      return false;
    }
    if (date < dayjs() && periodType === "Weekly" && date.day() !== 1) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date < dayjs() && periodType === "Monthly" && date.date() !== 1) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date > createToDate) {
      showMessage("Invalid from date", "info");
      return false;
    }
    return true;
  };

  const validToDate = (date) => {
    console.log("To Date", date);
    if (periodType.length <= 0) {
      showMessage("Please select period type first", "info");
      return false;
    }
    if (periodType === "Weekly" && date.day() !== 0) {
      showMessage("Chosen day must be Sunday for weekly period type", "info");
      return false;
    }
    if (periodType === "Monthly" && !date.isSame(date.endOf("month"), "day")) {
      showMessage(
        "Chosen day must be last day of month for monthly period type",
        "info"
      );
      return false;
    }
    if (date < dayjs()) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date < createFromDate) {
      showMessage("Invalid from date", "info");
      return false;
    }
    return true;
  };

  const handleCreateFromDate = (newDate) => {
    if (validFromDate(newDate)) {
      dispatch(setState("createFromDate", newDate));
    }
  };

  const handleCreateToDate = (newDate) => {
    if (validToDate(newDate)) {
      dispatch(setState("createToDate", newDate));
    }
  };

  const handleScenarioName = (event) => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country first", "info");
      return;
    }
    const value = event.target.value;
    dispatch(setState("scenarioName", value));
  };

  const handlePeriodType = (event) => {
    if (scenarioName.length <= 0) {
      showMessage("Please enter scenario name first", "info");
      return;
    }
    const value = event.target.value;
    dispatch(setState("periodType", value));
  };

  const handleCheckedUpdate = (event, stateName) => {
    const option = event.target.checked;
    dispatch(setState(stateName, option));
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant="subtitle1"
        sx={{ color: "lightBlue.main", fontWeight: "bold", mb: 0 }}
        className="compHeading"
      >
        Define Scenario Parameters
      </Typography>
      <Box
        sx={{
          mt: 2,
          mb: 4,
          border: 1,
          borderRadius: 1,
          borderColor: "#c8c8c8",
          p: 2,
        }}
      >
        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <Box sx={{}}>
              <TextField
                id="input-with-icon-textfield"
                label="Scenario Name"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
                variant="standard"
                sx={{
                  height: sizes.h45,
                  mt: 1,
                  width: "100%",
                }}
                value={scenarioName}
                onChange={handleScenarioName}
              />
            </Box>
          </Grid>

		  <Grid item xs={2} sm={2} md={2} lg={2}>
            <Box sx={{}}>
              <FormControl sx={{mt:1}}
              >
                <InputLabel id="demo-simple-select-label">
                  Period Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={periodType}
                  label="Period Type"
                  onChange={handlePeriodType}
                >
                  {periodTypes.map((type, index) => {
                    return (
                      <MenuItem value={type.name} key={index}>
                        {type.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          

          <Grid item xs={10} sm={6} md={2} lg={2}>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{
                    height: sizes.h45,
                    mt: 1,
                    width: "100%",
                  }}
                  // minDate={minSelectableDate}
                  minDate={dayjs(minDate)}
                  label="From"
                  value={createFromDate}
                  onChange={(newValue) => handleCreateFromDate(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{ width: sizes.w200 }}
                    />
                  )}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </Box>
          </Grid>
          <Grid item xs={10} sm={10} md={2} lg={2}>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{
                    height: sizes.h45,
                    mt: 1,
                    width: "100%",
                  }}
                  // minDate={minSelectableDate}
                  minDate={dayjs(minDate)}
                  label="To"
                  value={createToDate}
                  onChange={(newValue) => handleCreateToDate(newValue)}
                  format="DD/MM/YYYY"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{ width: sizes.w200, height: commonHeight }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Grid>

		  <Grid item xs={2} sm={2} md={2} lg={2}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                mt: 1,
                width: 1,
              }}
            >
              <Typography variant="subtitle2" sx={{ mt: 1.5 }}>
                Status: &nbsp;
              </Typography>
              <Chip
                sx={{ mt: 0.5, ml: 2, minWidth: "80px", fontWeight: 600 }}
                label={scenarioStatus}
              />
            </Box>
          </Grid>

          <Grid item xs={10} sm={10} md={1.5} lg={1.5}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                mt: 1,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sentToSAP}
                    onChange={(event) =>
                      handleCheckedUpdate(event, "sentToSAP")
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
              />

              <Typography
                variant="subtitle2"
                sx={{ mt: 1.5, ml: -2, fontSize: 14 }}
              >
                Send to SAP
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
